import React, { useContext } from 'react';
import classnames from 'classnames';
import EventList from '../../../components/EventList';
import DiscoveryContext from '../../../../../contexts/discoveryContext/contextV2';
import { list } from '../../../styles.module.css';
import { container, text, mapMode as mapModeStyle } from './styles.module.css';

const SpecificEventList = ({
  headerText,
  events,
  query,
  trackingSource,
  eventListClassName,
  mapProps = {},
  mapMode = false,
}) => {
  const {
    filters: {
      location: { name },
    },
  } = useContext(DiscoveryContext);

  const subtitleText = `${events.length} event${
    events.length > 1 ? 's' : ''
  } found around '${name}'`;

  return (
    <>
      <div className={classnames(container, { [mapModeStyle]: mapMode })}>
        <h1>{headerText}</h1>
        <span className={text}>{subtitleText}</span>
      </div>
      <EventList
        className={classnames(list, eventListClassName)}
        query={query}
        events={events}
        source={trackingSource}
        total={events.length}
        showLoadMore={false}
        hidePaginationLabel
        {...mapProps}
      />
    </>
  );
};

export default SpecificEventList;
